import api from "./api";



export async function fetchAssinaturaStatus() {

  const { data } = await api.get("/assinaturas/status");

  return data;

}



export async function contratarAssinatura(payload) {

  const { data } = await api.post("/assinaturas/contratar", payload);

  return data;

}



export async function cancelarAssinaturaApi() {

  const { data } = await api.post("/assinaturas/cancelar");

  return data;

}



export async function simularPagamentoApi() {

  const { data } = await api.post("/assinaturas/simular-pagamento");

  return data;

}

export async function cancelarPagamentoPendenteApi() {
  const { data } = await api.post("/assinaturas/cancelar-pagamento-pendente");
  return data;
}

export async function agendarTrocaPlanoApi({ plano, periodo }) {
  const { data } = await api.post("/assinaturas/agendar-troca", { plano, periodo });
  return data;
}

export async function cancelarTrocaAgendadaApi() {
  const { data } = await api.post("/assinaturas/cancelar-troca-agendada");
  return data;
}

export async function renovarAssinaturaApi(payload) {
  const { data } = await api.post("/assinaturas/renovar", payload);
  return data;
}

export async function desativarRenovacaoAutomaticaApi() {
  const { data } = await api.post("/assinaturas/desativar-renovacao-automatica");
  return data;
}

export async function sincronizarPagamentoPendenteApi() {
  const { data } = await api.post("/assinaturas/sincronizar-pagamento-pendente");
  return data;
}


